import { Component, OnInit, Input } from '@angular/core';
import { PopupObservationService } from '@services/observationDetail/popup-observation.service';
import { PopoverService } from '@services/popover/popover.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-archive-popup',
  templateUrl: './archive-popup.component.html',
  styleUrls: ['./archive-popup.component.scss'],
})
export class ArchivePopupComponent implements OnInit {
  @Input() observationID: Number;

  constructor(private popoverService: PopoverService,
              private popOps: PopupObservationService,
              private router: Router) {
  }

  ngOnInit() {
  }

  public async close(): Promise<void> {
    await this.popoverService.safeDismiss();
  }

  public async save(): Promise<void> {
    this.popOps.archive(this.observationID);
    await this.popoverService.safeDismiss();
  }

}
